<main [@fadeInOut] id="main-heading" role="main" tabindex="0">
  <div class="container-fluid padding-bottom-small bottom-padding">
    <div class="col-sm-11 center-block">

        <h1 tabindex="0" aria-label="Edit Order">Edit Order</h1>

        <form [formGroup]="orderStep3Form"
              novalidate>
            <div class="row">
                <!--------------------------------
                LEFT PANEL
                --------------------------------->
                <div class="col-sm-9">

                    <!--------------------------------
                    HEADER BUTTONS
                    --------------------------------->
                    <div class="row">

                      <div class="col-sm-4">
                        <a [routerLink]="['/order-step-1/', orderRevisionId]" class="text-decoration-none">
                          <div class="card mb-5" tabindex="0" aria-label="Order Type">
                              <div class="card-header">
                                  <span class="badge bg-dark text-white">1</span>&nbsp;<b class="text-dark">ORDER TYPE</b>
                              </div>
                          </div>
                        </a>
                      </div>

                      <div class="col-sm-4">
                        <a [routerLink]="['/order-step-2/', orderRevisionId]" class="text-decoration-none">
                          <div class="card mb-5" tabindex="0" aria-label="Additional Options">
                              <div class="card-header">
                                <span class="badge bg-dark text-white">2</span>&nbsp;<b>ADDITIONAL OPTIONS</b>
                              </div>
                          </div>
                        </a>
                      </div>

                      <div class="col-sm-4">
                          <div class="card mb-5" tabindex="0" aria-label="Place Order">
                              <div class="card-header bg-primary text-white">
                                <span class="badge bg-white text-primary">3</span>&nbsp;<b>PLACE ORDER</b>
                              </div>
                          </div>
                      </div>
                    </div>

                    <!--------------------------------
                    INSTRUCTIONS
                    --------------------------------->
                    <div class="row top-space">
                        <div class="col-sm-12">
                            <h2 tabindex="0" aria-label="Instructions">Instructions</h2>
                            <p tabindex="0" aria-label="Information">
                                Help us get it right the first time.
                                Please provide instructions for each section you're editing.
                            </p>
                        </div>
                    </div>

                    <!--------------------------------
                    COL OR DRUG FACT CHANGES
                    --------------------------------->
                    <div *ngIf="showTextboxesForChanges" class="row top-space">
                        <div class="col-sm-12">
                            <h3 tabindex="0" aria-label="Content of labeling or drug fact changes?">Content of labeling or drug fact changes?</h3>
                            <textarea formControlName="colOrDrugFactChangeInstruction"
                                      name="colOrDrugFactChangeInstruction"
                                      rows="4"
                                      aria-label="Tell us what changed"
                                      tabindex="0"
                                      class="form-control"
                                      placeholder="Tell us what changed..."
                                      maxlength="255"
                                      [readonly]="!canEdit"></textarea>
                        </div>
                    </div>

                    <!--------------------------------
                    PRINCIPAL DISPLAY PANEL CHANGES
                    --------------------------------->
                    <div *ngIf="showTextboxesForChanges" class="row top-space">
                        <div class="col-sm-12">
                            <h3 tabindex="0" aria-label="Principal display panel changes?">Principal display panel changes?</h3>
                            <textarea formControlName="principalDisplayPanelChangeInstruction"
                                      name="principalDisplayPanelChangeInstruction"
                                      rows="4"
                                      class="form-control"
                                      aria-label="Tell us what changed"
                                      tabindex="0"
                                      placeholder="Tell us what changed..."
                                      maxlength="255"
                                      [readonly]="!canEdit"></textarea>
                        </div>
                    </div>

                    <!--------------------------------
                    LL META DATA CHANGES
                    --------------------------------->
                    <div *ngIf="showTextboxesForChanges" class="row top-space">
                        <div class="col-sm-12">
                            <h3 tabindex="0" aria-label="Labeling or listing (metadata) changes?">Labeling/listing (metadata) changes?</h3>
                            <textarea formControlName="LLMetadataChangeInstruction"
                                      name="LLMetadataChangeInstruction"
                                      rows="4"
                                      class="form-control"
                                      aria-label="Tell us what changed"
                                      tabindex="0"
                                      placeholder="Tell us what changed..."
                                      maxlength="255"
                                      [readonly]="!canEdit"></textarea>
                        </div>
                    </div>

                    <!--------------------------------
                    COMMENTS
                    --------------------------------->
                    <div class="row top-space">
                        <div class="col-sm-12">
                            <h3 tabindex="0" aria-label="Instructions">Instructions</h3>
                            <textarea formControlName="comments"
                                      name="comments"
                                      rows="4"
                                      aria-label="Comments"
                                      tabindex="0"
                                      class="form-control"
                                      placeholder=""
                                      maxlength="255"
                                      [readonly]="!canEdit"></textarea>
                        </div>
                    </div>

                    <!--------------------------------
                    BUTTONS
                    --------------------------------->
                    <div class="row">
                        <div class="col-md-12 top-space">
                            <a class="btn btn-default" routerLink="/order-tracker" aria-label="Back to list">
                                <i class="fas fa-angle-left" aria-hidden="true"></i>
                                Back to list
                            </a>
                            <button *ngIf="canSubmitOrder" class="btn btn-primary float-end mx-1" role="button" aria-label="Submit order"
                                    (click)="saveData('SUBMIT')"
                                    (keydown.enter)="saveData('SUBMIT')"
                                    [disabled]="!orderStep3Form.valid || (pageState !== orderService.PAGE_STATE_READY) || !(canEdit || orderAdmin)">
                                Submit order
                                <i class="fas fa-angle-double-right" aria-hidden="true"></i>
                            </button>
                            <button class="btn btn-info float-end mx-1t" role="button" aria-label="Save button"
                                    (click)="saveData('STEP3');"
                                    (keydown.enter)="saveData('STEP3');"
                                    [disabled]="!orderStep3Form.valid || (pageState !== orderService.PAGE_STATE_READY) || !(canEdit || orderAdmin)">
                                {{saveButtonCaption}}
                            </button>
                            <button class="btn btn-primary float-end mx-1" role="button" aria-label="Previous step"
                                    (click)="saveData('STEP2')"
                                    (keydown.enter)="saveData('STEP2')"
                                    id="btnPrevious"
                                    [disabled]="!orderStep3Form.valid || (pageState !== orderService.PAGE_STATE_READY)">
                                <i class="fas fa-angle-double-left" aria-hidden="true"></i>
                                Previous step
                            </button>
                            <button class="btn btn-info float-end mx-1" role="button" aria-label="Request Order Cancellation"
                                    (click)="saveData('CANCEL');"
                                    (keydown.enter)="saveData('CANCEL');"
                                    *ngIf="canRequestCancellation">
                                Request Order Cancellation
                            </button>
                        </div>
                    </div>

                    <!--------------------------------
                    ERROR MESSAGE
                    --------------------------------->
                    <div class="row">
                        <div class="col-md-12 top-space">
                            <div *ngIf="errorMessage!=null && errorMessage!=''" class="alert-text left-padding alert">{{errorMessage}}</div>
                        </div>
                    </div>

                </div>

                <!--------------------------------
                RIGHT PANEL
                --------------------------------->
                <div class="col-sm-3">
                    <!--------------------------------
                    ORDER SUMMARY
                    --------------------------------->
                    <order-summary whichStep="STEP3"
                                   [order]="order"
                                   [allEmployeesInCompany]="allEmployeesInCompany"
                                   [serviceCategories]="serviceCategories">
                    </order-summary>

                    <p>&nbsp;</p>

                    <!--------------------------------
                    ORDER ADMIN
                    --------------------------------->
                    <order-admin #orderAdminComponent
                                 *ngIf="canOrderAdmin"
                                 [orderStatuses]="orderStatuses"
                                 [order]="order"
                                 [canEdit]="canEdit"
                                 [postSaveDataNewOrderRevisionId]="postSaveDataNewOrderRevisionId"
                                 [deliveryDoc]="deliveryDoc"
                                 (onOrderAdminFileUpload)="onOrderAdminFileUpload($event)"
                                 (onIngestFilechanged)="onIngestFilechanged($event)">
                    </order-admin>
                </div>
            </div>
        </form>

        <!--------------------------------
        PROGRESS SPINNER
        --------------------------------->
        <div *ngIf="pageState !== this.orderService.PAGE_STATE_READY">
            <div id="loading"></div>
        </div>
    </div>
</div>
</main>


